import { CSSProperties, useState } from "react";
import { PATH_PORTFOLIO_SECTION } from "../../../utility/constants";
import { PortfolioItemType } from "../../../utility/types/generaTypes";
import { PORTFOLIO } from "../../../utility/utilityData";
import Button from "../../common/buttons/button/Button";
import PortfolioCard from "../portfolioCard/PortfolioCard";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./PortfolioSection.css";

type PortfolioSectionProps = {
  isHomePage?: boolean;
  isOtherPage?: boolean;
  sectionHeading?: string;
  headingPart1: string;
  headingPart2?: string;
  description: string;
  portfolio: PortfolioItemType[];
  style?: CSSProperties;
};

const PortfolioSection = ({
  isHomePage,
  isOtherPage,
  sectionHeading,
  headingPart1,
  headingPart2,
  description,
  portfolio,
  style,
}: PortfolioSectionProps) => {
  const [loadMore, setLoadMore] = useState(false);

  const visibleCards = loadMore ? PORTFOLIO.length : 6;

  return (
    <section id={PATH_PORTFOLIO_SECTION} style={style}>
      <div className="app_section">
        {(isHomePage || isOtherPage) && (
          <div className="appSection_header_container">
            {isHomePage && <SectionHeader title={`💼 Our Portfolio`} />}
            <h1 className="section_title">
              {headingPart1}{" "}
              <span className="gradient_text"> {headingPart2} </span>
            </h1>
            <p className="section_description">{description}</p>
          </div>
        )}
        {/* 
      <div className="tabs_main_container">
        {TAB.map((tab, index) => (
          <Tab
            key={"Tab" + index}
            tab={tab}
            activeTab={activeTab}
            onClickTab={() => setActiveTab(tab?.type)}
          />
        ))}
      </div> */}
        <div className="portfolioCards_container">
          {portfolio.slice(0, visibleCards).map((portfolio, index) => (
            <PortfolioCard
              key={"PortfolioCard" + index}
              portfolio={portfolio}
            />
          ))}
        </div>
        {portfolio.length > 6 && (
          <Button
            title={loadMore ? "Show Less" : "Load More Project"}
            onClickButton={() => setLoadMore(!loadMore)}
            isSecodary
            className="portfolio_lodeMoreBtn"
            color="black"
          />
        )}
        {/* )} */}
      </div>
    </section>
  );
};

// type TabProps = {
//   tab: TabItemType;
//   activeTab: TabType;
//   onClickTab: () => void;
// };
// const Tab = ({ tab, activeTab, onClickTab }: TabProps) => {
//   return (
//     <div
//       onClick={onClickTab}
//       className="tab_container"
//       style={{
//         background:
//           activeTab === tab?.type ? "hsl(214 84% 56%)" : "transparent",
//         border:
//           activeTab === tab?.type
//             ? "1px solid hsl(214 84% 56%)"
//             : "1px solid rgb(216, 216, 216)",
//       }}
//     >
//       <p style={{ color: activeTab === tab?.type ? "white" : "black" }}>
//         {tab?.label}
//       </p>
//     </div>
//   );
// };

export default PortfolioSection;
